export const getS3DownloadURL = (
  bucket: string,
  region: string,
  name: string
): string => {
  return `https://${bucket || ""}.s3.${region || ""}.amazonaws.com/${name}`;
};

/** Get file URL - prefers pre-signed url from Lambda, falls back to direct S3 URL */
export const getFileUrl = (
  file: { Key?: string; url?: string },
  bucket?: string,
  region?: string
): string => {
  if ("url" in file && file.url) return file.url;
  const b = bucket ?? process.env.REACT_APP_AWS_S3_BUCKET ?? "";
  const r = region ?? process.env.REACT_APP_AWS_REGION ?? "";
  return getS3DownloadURL(b, r, file.Key || "");
};

/**
 * Removes the `__typename`, `createdAt`, and `updatedAt` fields from an object to prepare it for database operations.
 *
 * This function is commonly used when converting GraphQL objects (which contain `__typename`)
 * to database input objects that don't need these fields.
 *
 * @param data - The object from which to remove the specified fields. Must be a valid object.
 * @returns A new object with all properties except `__typename`, `createdAt`, and `updatedAt`, or the original data if invalid or an array.
 *
 * @example
 * const graphqlObject = {
 *   __typename: "User",
 *   id: "123",
 *   name: "John Doe",
 *   email: "john@example.com",
 *   createdAt: "2023-01-01T00:00:00Z",
 *   updatedAt: "2023-01-02T00:00:00Z"
 * };
 *
 * const dbInput = convertToCreateInput(graphqlObject);
 * Result: { id: "123", name: "John Doe", email: "john@example.com" }
 */
export const convertToCreateInput = (data: any) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return data;
  }

  const { __typename, _version, _lastChangedAt, _deleted, createdAt, updatedAt, id, ...dataWithoutFields } = data;
  return dataWithoutFields;
};
